import styles from './app.module.scss';
import { RouteConfig } from '@/routes/RouteConfig';

function App() {
  return (
    <div className={`${styles.app} ${styles.fade_in}`}>
      <div className={styles.l_contents}>
        <RouteConfig />
      </div>
    </div>
  );
}

export default App;
